import * as React from "react";
import { observer } from "mobx-react";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "../TravelersHiddenInputType";
import { TravelersHiddenInputsProps } from "../typings";

export const TravelersHiddenInputs = observer(
  ({ hiddenInputType, flightSearch, hotelSearch, packageSearch, cruiseSearch }: TravelersHiddenInputsProps) => {
    switch (hiddenInputType) {
      case TRAVELERS_HIDDEN_INPUT_TYPE.FLIGHT_SEARCH:
        return (
          <input
            type="hidden"
            name="passengers"
            value={flightSearch}
            data-testid="passengers-input"
            key="hidden-flight-search"
          />
        );
      case TRAVELERS_HIDDEN_INPUT_TYPE.HOTEL_SEARCH:
        return (
          <>
            <input type="hidden" name="rooms" value={hotelSearch.rooms} data-testid="rooms-input" />
            <input
              type="hidden"
              name="adults"
              value={hotelSearch.adults}
              data-testid="adults-input"
              key="hidden-hotel-search-adults"
            />
            {hotelSearch.children && (
              <input
                type="hidden"
                name="children"
                value={hotelSearch.children}
                data-testid="children-input"
                key="hidden-hotel-search-children"
              />
            )}
          </>
        );
      case TRAVELERS_HIDDEN_INPUT_TYPE.PACKAGE_SEARCH:
        const packageSearchInputs = [];
        for (const key of Object.keys(packageSearch)) {
          packageSearchInputs.push(
            <input
              type="hidden"
              name={key}
              value={packageSearch[key]}
              data-testid={`${key}-input`}
              key={`hidden-package-search-${key}`}
            />
          );
        }

        return <>{packageSearchInputs}</>;
      case TRAVELERS_HIDDEN_INPUT_TYPE.CRUISE_SEARCH:
        return (
          <>
            <input
              type="hidden"
              name="adultCount"
              value={cruiseSearch.numOfAdults}
              data-testid="cruise-adults-input"
              key="hidden-cruise-search-adults"
            />
            {cruiseSearch.numOfChildren > 0 && (
              <input
                type="hidden"
                name="childCount"
                value={cruiseSearch.numOfChildren}
                data-testid="cruise-children-input"
                key="hidden-cruise-search-children"
              />
            )}
            {cruiseSearch.numOfChildren > 0 && (
              <input
                type="hidden"
                name="childAges"
                value={cruiseSearch.childAges}
                data-testid="cruise-childAges-input"
                key="hidden-cruise-search-childAges"
              />
            )}
          </>
        );
      default:
        return <></>;
    }
  }
);
